module.exports = __webpack_public_path__ + "img/poster-1.d896c240.jpg";